import { apiClient } from 'shared/api-client';

import type { RegisterSourceData } from '../analytics/registerSource';

export const updateRegisterSource = async (data: RegisterSourceData) => {
  const { slug, ...custom_data } = data;
  return apiClient.post('bi/api/registersource/', {
    json: { slug, custom_data },
  });
};
